import "./pannellum/pannellum";
import "./pannellum/libpannellum";
import {
  fromEvent,
  scheduled,
  asapScheduler,
  BehaviorSubject,
  Observable,
} from "rxjs";
import { mergeAll, debounceTime } from "rxjs/operators";

declare let pannellum: any;

export class PannellumComponent {
  private tourData: Record<string, any> = {};

  public viewer: any;

  public pitch: number;
  public yaw: number;
  public hFov: number;
  protected shouldRotate: BehaviorSubject<boolean>;

  private div: HTMLDivElement;

  public $yaw: BehaviorSubject<number>;
  public $pitch: BehaviorSubject<number>;

  private rotating: boolean;
  private changingScene: boolean;

  constructor() {
    this.div = document.querySelector("#pannellum");
    this.shouldRotate = new BehaviorSubject<boolean>(false);
  }

  public start(tourData: Record<string, any>): void {
    this.tourData = Object.assign({}, { ...tourData });
    this.tourData.default.hFov = this.calculatedHFOV;
    this.pitch = this.tourData.default.pitch;
    this.yaw = this.tourData.default.yaw;
    this.hFov = this.calculatedHFOV;
    this.$pitch = new BehaviorSubject<number>(this.pitch);
    this.$yaw = new BehaviorSubject<number>(this.yaw);
    this.viewer = pannellum.viewer(this.div, this.tourData);
    this.bindEvent();
    this.adjustFOV();
    this.updateRotation();
    this.shouldRotate.next(true);
  }

  private get calculatedHFOV(): number {
    const height = window.innerHeight;
    const width = window.innerWidth;
    return height > width ? 67.5 : 120;
  }

  private adjustFOV(): void {
    this.viewer.setHfov(this.calculatedHFOV, 0);
  }

  private bindEvent(): void {
    scheduled(
      [
        fromEvent(this.viewer, "scenechange"),
        fromEvent(this.viewer, "scenechangefadedone"),
      ],
      asapScheduler
    )
      .pipe(mergeAll())
      .subscribe(() => {
        this.changingScene = false;
        setTimeout(() => {
          // this.viewer.setPitch(this.pitch, false);
          // this.viewer.setYaw(this.yaw, false);
          // this.viewer.setHfov(this.hFov, 0);
          this.stopAutoRotate();
          this.shouldRotate.next(true);
        }, 0);
      });

    scheduled(
      [
        fromEvent(this.viewer, "mouseup"),
        fromEvent(this.viewer, "touchend"),
        fromEvent(this.viewer, "animatefinished"),
      ],
      asapScheduler
    )
      .pipe(mergeAll())
      .subscribe(() => {
        this.stopAutoRotate();
        this.shouldRotate.next(true);
      });

    scheduled(
      [
        fromEvent(this.viewer, "mousedown"),
        fromEvent(this.viewer, "touchstart"),
      ],
      asapScheduler
    )
      .pipe(mergeAll())
      .subscribe(() => {
        this.stopAutoRotate();
        this.shouldRotate.next(false);
      });

    // fromEvent(this.viewer, "zoomchange").subscribe((hFov: number) => {
    //   this.hFov = hFov;
    //   console.log(this.hFov);
    // });

    this.shouldRotate.pipe(debounceTime(10000)).subscribe((shouldRotate) => {
      if (shouldRotate) {
        this.startAutoRotate();
      }
    });

    window.addEventListener("resize", () => {
      this.adjustFOV();
    });
  }

  private updateRotation() {
    this.$pitch.next(this.viewer.getPitch());
    this.$yaw.next(this.viewer.getYaw());
    setTimeout(() => {
      requestAnimationFrame(() => this.updateRotation());
    }, 500);
  }

  public startAutoRotate(): void {
    if (!this.rotating) {
      this.viewer.startAutoRotate(-2, 0);
      this.rotating = true;
    }
  }
  public stopAutoRotate(): void {
    this.viewer.stopAutoRotate();
    this.rotating = false;
  }

  public changeScene(scene: string): void {
    this.changingScene = true;
    // this.hFov = this.viewer.getHfov();
    this.viewer.loadScene(
      scene,
      this.viewer.getPitch(),
      this.viewer.getYaw(),
      this.viewer.getHfov()
    );
  }

  public onLoad(): Observable<void> {
    return fromEvent(this.viewer, "load");
  }

  public getYaw(): number {
    return this.yaw;
  }

  public getPitch(): number {
    return this.pitch;
  }
}
